export const getLocalStorage = () => localStorage;
